module.exports = __webpack_public_path__ + "static/media/facebook-share.5b1cc8d8.svg";